// Spanish translation

const es = {
  "hotel.calendar.select_date": "Fecha",
  "hotel.calendar.rates": "Tarifas y Disponibilidad",
  "hotel.calendar.update_range": "Update Range",
  "hotel.calendar.update_start_date": "Start Date",
  "hotel.calendar.update_end_date": "End Date",
  "hotel.calendar.line": "Prices",
  "hotel.calendar.line.accommodation": "Accommodation",
  "hotel.calendar.line.price_list": "Price List",
  "hotel.calendar.line.unit_price": "Unit Price",
  "hotel.calendar.rate_plan": "Plan Tarifario",
  "hotel.calendar.company.operation_center": "Centro de Operaciones",
  "hotel.calendar.no_data_available": "Sin datos",
  "hotel.calendar.error_no_calendar":
    "Error no hay calendario disponible para el plan tarifario seleccionado!",
  "hotel.calendar.update": "Actualizar",
  "button.hotel.calendar.update": "Actualizar",
};

export default es;
